var blockquote_default = {
  "fontElementMap": "_9kWEf",
  "quote": "_0Rimk"
};
export {
  blockquote_default as default
};
//# sourceMappingURL=blockquote-scss.js.map
